export const generateNextCopyName = (name: string): string  => {
  const copyRegex = /\(copy(?: (\d+))?\)$/;

  const match = name.match(copyRegex);

  if (!match) {
    return `${name} (copy)`;
  }

  if (!match[1]) {
    return name.replace(copyRegex, '(copy 1)');
  }

  const currentNumber = parseInt(match[1], 10);
  const nextNumber = currentNumber + 1;

  return name.replace(copyRegex, `(copy ${nextNumber})`);
}
